export const SubscriptionTypes = {
  ONE_TIME: 'one_time',
  SUBSCRIPTION_NO_CANCELLATION: 'subscription_no_cancellation', 
  SUBSCRIPTION_CANCELLATION_ALLOWED: 'subscription_cancellation_allowed'
};

export const SubscriptionTypeLabels = {
  [SubscriptionTypes.ONE_TIME]: 'One-Time Payment',
  [SubscriptionTypes.SUBSCRIPTION_NO_CANCELLATION]: 'Subscription (Fixed Commitment)',
  [SubscriptionTypes.SUBSCRIPTION_CANCELLATION_ALLOWED]: 'Subscription (Flexible Monthly)'
};

export const SubscriptionTypeDescriptions = {
  [SubscriptionTypes.ONE_TIME]: 'Pay once and get lifetime access. No recurring charges, full payment upfront.',
  [SubscriptionTypes.SUBSCRIPTION_NO_CANCELLATION]: 'Fixed-term subscription with commitment. Lower monthly rate but cannot cancel during term.',
  [SubscriptionTypes.SUBSCRIPTION_CANCELLATION_ALLOWED]: 'Month-to-month subscription. Cancel anytime, higher flexibility with slightly higher monthly rate.'
};

// Updated policies focusing on PAYMENT models, not service delivery
export const SubscriptionPolicies = {
  [SubscriptionTypes.ONE_TIME]: {
    payment: {
      type: 'single_payment',
      description: 'Full payment charged immediately',
      benefits: ['Lifetime access', 'No recurring charges', 'Often discounted compared to subscription']
    },
    refund: {
      allowed: true,
      period: '7-30 days from purchase',
      conditions: [
        'Service not utilized or accessed', 
        'Technical issues preventing access',
        'Service not as described'
      ],
      restrictions: [
        'After significant service usage',
        'If custom work has been started',
        'After 30 days of purchase'
      ]
    },
    cancellation: {
      allowed: true,
      conditions: [
        'Before service activation or access',
        'During cooling-off period'
      ],
      note: 'Once service is activated, standard refund policy applies'
    },
    access: 'Lifetime access after one-time payment'
  },
  [SubscriptionTypes.SUBSCRIPTION_NO_CANCELLATION]: {
    payment: {
      type: 'recurring_fixed',
      description: 'Fixed monthly/quarterly/yearly payments for commitment period',
      benefits: ['Lower monthly rate', 'Price lock for commitment period', 'Dedicated service continuity']
    },
    refund: {
      allowed: true,
      conditions: [
        'Unused portion of subscription',
        'Service outages or technical failures',
        'Billing errors'
      ],
      restrictions: [
        'Cannot cancel during commitment period',
        'No refund for current billing cycle if service was accessible'
      ]
    },
    cancellation: {
      allowed: false,
      conditions: [
        'Only during initial cooling-off period',
        'After commitment period ends - can choose not to renew'
      ],
      note: 'Fixed commitment ensures stable pricing and service allocation'
    },
    access: 'Continuous access during subscription period, auto-renews unless canceled before renewal'
  },
  [SubscriptionTypes.SUBSCRIPTION_CANCELLATION_ALLOWED]: {
    payment: {
      type: 'recurring_flexible',
      description: 'Monthly payments that can be canceled anytime',
      benefits: ['Maximum flexibility', 'No long-term commitment', 'Easy to upgrade/downgrade']
    },
    refund: {
      allowed: true,
      conditions: [
        'Unused portion of current month',
        'Service performance issues',
        'Billing discrepancies'
      ],
      restrictions: [
        'Current month payment is non-refundable if service was accessible',
        'No pro-rated refunds in most cases'
      ]
    },
    cancellation: {
      allowed: true,
      conditions: [
        'Cancel anytime without penalties',
        'Effective at the end of current billing cycle',
        'No future charges after cancellation'
      ],
      note: 'Service continues until the end of paid period after cancellation'
    },
    access: 'Month-to-month access, continues until canceled'
  }
};
